export function AccountNotSentToBilling() {
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-6 py-16 text-center">
      <p className="text-2xl font-semibold">Account has not been sent to billing</p>
      <p className="max-w-md text-lg text-text-secondary">
        Customer payment information will be available when the account is ready for billing.
      </p>
    </div>
  );
}
